import { Scene } from "excalibur";

export class MainMenuScene extends Scene {}
